module.exports = __webpack_public_path__ + "img/20210823_124050.b5d10e4d.jpg";